import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BAWizard from '../components/estimation/BAWizard';
import TextInput from '../components/estimation/TextInput';
import ResultView from '../components/estimation/ResultView';
import { aiApi } from '../api/ai';
import { estimationsApi } from '../api/estimations';

const METHODS = [
  { id: 'text', label: '✏️ Escribir requerimiento', desc: 'Describe el proyecto directamente' },
  { id: 'wizard', label: '🤖 Wizard BA + Chat IA', desc: 'Guiado por preguntas del catálogo' },
];

export default function NewEstimation() {
  const [method, setMethod] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleAnalyze = async (description, projectName) => {
    setLoading(true);
    setError('');
    try {
      const response = await aiApi.analyze(description);
      setResult({ ...response.data, projectName, description });
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al analizar el proyecto');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (projectName, description, analysisResult) => {
    try {
      const data = {
        project_name: projectName,
        description: description,
        source_type: method === 'wizard' ? 'entrevista' : 'texto',
        complexity: analysisResult.complexity,
        total_hours: analysisResult.total_hours,
        phases_json: JSON.stringify(analysisResult.phases),
        ai_analysis: JSON.stringify(analysisResult),
        confidence: analysisResult.confidence,
      };
      const response = await estimationsApi.create(data);
      navigate(`/estimations/${response.data.id}`);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar la estimación');
    }
  };

  // Show result view
  if (result) {
    return (
      <ResultView
        result={result}
        onSave={() => handleSave(result.projectName, result.description, result)}
        onBack={() => setResult(null)}
        error={error}
      />
    );
  }

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800">Nueva estimación</h1>

      {/* Method selector */}
      {!method && (
        <div className="space-y-4">
          <p className="text-gray-500">Elige el método de entrada del requerimiento:</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {METHODS.map((m) => (
              <button
                key={m.id}
                onClick={() => setMethod(m.id)}
                className="bg-white rounded-xl border-2 border-gray-200 hover:border-blue-400 p-6 text-left transition-colors"
              >
                <span className="text-2xl">{m.label.split(' ')[0]}</span>
                <h3 className="mt-2 font-semibold text-gray-800">{m.label.slice(3)}</h3>
                <p className="mt-1 text-sm text-gray-500">{m.desc}</p>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Text input method */}
      {method === 'text' && (
        <TextInput
          onAnalyze={handleAnalyze}
          onBack={() => setMethod(null)}
          loading={loading}
          error={error}
        />
      )}

      {/* Wizard BA method */}
      {method === 'wizard' && (
        <BAWizard
          onComplete={handleAnalyze}
          onBack={() => setMethod(null)}
          loading={loading}
          error={error}
        />
      )}
    </div>
  );
}
